import { Controller } from "@hotwired/stimulus"

// Toggling a core-feature switch redirects back to the settings page so the
// global chrome (header nav, sidebars) re-renders with the new state. That
// redirect drives a fresh Turbo visit, which snaps the window back to the top
// and loses the admin's place in a long list of toggles (CORE-8938).
//
// This controller stashes the scroll position when a switch is submitted and
// restores it once the re-rendered page has settled. sessionStorage survives
// both a Turbo visit and a hard reload, so the fix holds either way.
export default class extends Controller {
  static values = { key: { type: String, default: "scrollPreserve" } }

  connect() {
    this.save = this.save.bind(this)
    this.element.addEventListener("turbo:submit-start", this.save)
    this.restore()
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.save)
  }

  save() {
    sessionStorage.setItem(this.keyValue, String(window.scrollY))
  }

  restore() {
    const stored = sessionStorage.getItem(this.keyValue)
    if (stored === null) return

    // Restore on turbo:load so we run after Turbo has finished its own
    // scroll-to-top for this render, then clear the key so an unrelated later
    // visit isn't yanked back to this position.
    document.addEventListener(
      "turbo:load",
      () => {
        sessionStorage.removeItem(this.keyValue)
        const y = parseInt(stored, 10)
        if (!Number.isNaN(y)) window.scrollTo(0, y)
      },
      { once: true },
    )
  }
}
